export const ADD_CODES = 'ADD_CODES';
export const addCodes = (codeType, codes) => ({type: ADD_CODES, payload: {codes, codeType}});
export const API_GET_CODES = 'API_GET_CODES';
export const getCodes = (codeType) => ({type: API_GET_CODES, payload: {codeType}});
export const API_GET_CODE = 'API_GET_CODE';
export const getCode = (codeType, code) => ({type: API_GET_CODE, payload: {codeType, code}});
export const API_GET_CODES_DONE = 'API_GET_CODES_DONE';
export const getCodeDone = (response) => ({type: API_GET_CODES_DONE, payload: response});


// WEBPACK FOOTER //
// ./src/actions/codes.js